import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=18d90e9c&scoped=true"
import script from "./AppSetting.vue?vue&type=script&lang=js"
export * from "./AppSetting.vue?vue&type=script&lang=js"
import style0 from "./AppSetting.vue?vue&type=style&index=0&id=18d90e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d90e9c",
  null
  
)

export default component.exports